import styled from 'styled-components';

const TextArea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  font-family: inherit;
  border: 1px solid #715aff;
  border-radius: 5px;
  outline: none;
  resize: none;

  &:focus:not(:disabled) {
    box-shadow: 0 0 0.5px #715aff;
  }

  &:disabled {
    background-color: #f2f2f2;
  }
`;

export default TextArea;
